// import React, { useState, useEffect } from "react";
// import api from "@/auth/api";
// import { alertSuccess, alertError } from "@/components/Alert";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchVariableList } from "@/slices/panelSlice/variableListSlice";

// // ================= Recursive Renderer =================
// const RenderValue = ({ value }) => {
//   if (Array.isArray(value)) {
//     return (
//       <ul className="list-disc ml-3 space-y-3">
//         {value.map((item, index) => (
//           <li key={index}>
//             <RenderValue value={item} />
//           </li>
//         ))}
//       </ul>
//     );
//   } else if (typeof value === "object" && value !== null) {
//     return (
//       <div className="ml-1 space-y-1">
//         {Object.entries(value).map(([key, val], index) => (
//           <div key={index}>
//             <span className="font-semibold text-gray-700">{key}:</span>{" "}
//             <RenderValue value={val} />
//           </div>
//         ))}
//       </div>
//     );
//   } else {
//     return (
//       <span className="break-words text-gray-800">
//         {String(value)}
//       </span>
//     );
//   }
// };

// // ================= MAIN COMPONENT =================
// function SingleTempRecord({ rowData }) {
//   const dispatch = useDispatch();

//   const { variableList } = useSelector(
//     (state) => state.variableList
//   );

//   const [tempData, setTempData] = useState([]);

//   // ✅ Always sync from Redux (fresh data)
//   useEffect(() => {
//     if (!variableList?.QuestionList || !rowData?.id) return;

//     const updatedItem = variableList.QuestionList?.find(
//       (v) => v.id === rowData.id
//     );

//     if (updatedItem?.Temp_Record) {
//       setTempData(updatedItem.Temp_Record);
//     }
//   }, [variableList, rowData]);

//   // ================= APPLY CHANGES =================
//   const handleApplyChanges = async (item) => {
//     try {
//       const resp = await api.post("/panel/PanelVariableUpdate", {
//         id: item.id,
//       });

//       alertSuccess(resp?.data?.success);

//       // ✅ Fetch fresh data → UI auto update via useEffect
//       dispatch(fetchVariableList());
//     } catch (err) {
//       alertError(err?.response?.data?.errors);
//     }
//   };

//   // ================= UI =================
//   return (
//     <div className="p-2 w-[500px]">
//       <div className="max-h-[500px] space-y-3 overflow-y-auto">
//         {tempData.map((item, index) => (
//           <div
//             key={index}
//             className={`relative border ${
//               item.Used ? "border-green-500" : "border-gray-300"
//             } p-5 rounded-lg shadow-md bg-white`}
//           >
//             {/* Status / Action */}
//             {item.Used ? (
//               <span className="absolute top-3 right-3 bg-green-500 text-white text-xs px-3 py-1 rounded">
//                 USED
//               </span>
//             ) : (
//               <button
//                 onClick={() => handleApplyChanges(item)}
//                 className="absolute top-3 right-3 bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1 rounded"
//               >
//                 Apply Changes
//               </button>
//             )}

//             {/* Content */}
//             <div className="text-sm leading-relaxed break-words">
//               <RenderValue value={item} />
//             </div>
//           </div>
//         ))}

//         {/* Empty State */}
//         {tempData.length === 0 && (
//           <div className="text-center text-gray-500 text-sm py-5">
//             No Temp Records Found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default SingleTempRecord;


import React, { useState, useEffect } from "react";
import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";
import { useDispatch, useSelector } from "react-redux";
import { fetchVariableList } from "@/slices/panelSlice/variableListSlice";

// ================= Recursive Renderer =================
const RenderValue = ({ value }) => {
  if (Array.isArray(value)) {
    return (
      <ul className="list-disc ml-3 space-y-3">
        {value.map((item, index) => (
          <li key={index}>
            <RenderValue value={item} />
          </li>
        ))}
      </ul>
    );
  } else if (typeof value === "object" && value !== null) {
    return (
      <div className="ml-1 space-y-1">
        {Object.entries(value).map(([key, val], index) => (
          <div key={index}>
            <span className="font-semibold text-gray-700">{key}:</span>{" "}
            <RenderValue value={val} />
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <span className="break-words text-gray-800">
        {String(value)}
      </span>
    );
  }
};

// ================= MAIN COMPONENT =================
function SingleTempRecord({ rowData }) {
  const dispatch = useDispatch();

  const { variableList } = useSelector(
    (state) => state.variableList
  );

  const [tempData, setTempData] = useState([]);

  // ✅ Always sync from Redux (fresh data)
  useEffect(() => {
    if (!variableList?.QuestionList || !rowData?.id) return;

    const updatedItem = variableList.QuestionList?.find(
      (v) => v.id === rowData.id
    );

    if (updatedItem?.Temp_Record) {
      setTempData(updatedItem.Temp_Record);
    }
  }, [variableList, rowData]);

  // ================= APPLY CHANGES =================
  const handleApplyChanges = async (item) => {
    try {
      const resp = await api.post("/panel/PanelVariableUpdate", {
        id: item.id,
      });

      alertSuccess(resp?.data?.success);

      // ✅ Fetch fresh data → UI auto update via useEffect
      dispatch(fetchVariableList());
    } catch (err) {
      alertError(err?.response?.data?.errors);
    }
  };

  // ================= UI =================
  return (
    <div className="p-2 w-[500px]">
      <div className="max-h-[500px] space-y-3 overflow-y-auto">
        {tempData.map((item, index) => (
          <div
            key={index}
            className={`relative border ${
              item.Used ? "border-green-500" : "border-gray-300"
            } p-5 rounded-lg shadow-md bg-white`}
          >
            {/* Status / Action */}
            {item.Used ? (
              <span className="absolute top-3 right-3 bg-green-500 text-white text-xs px-3 py-1 rounded">
                USED
              </span>
            ) : (
              <button
                onClick={() => handleApplyChanges(item)}
                className="absolute top-3 right-3 bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1 rounded"
              >
                Apply Changes
              </button>
            )}

            {/* Content */}
            <div className="text-sm leading-relaxed break-words">
              <RenderValue value={item} />
            </div>
          </div>
        ))}

        {/* Empty State */}
        {tempData.length === 0 && (
          <div className="text-center text-gray-500 text-sm py-5">
            No Temp Records Found
          </div>
        )}
      </div>
    </div>
  );
}

export default SingleTempRecord;